export default __webpack_public_path__ + "static/media/Icon_awesome_calendar_day.33933732.svg";